<template>
  <div class="countdown-wrapper" v-if="time">
    {{ time }}
  </div>
</template>
<script>
  // 倒计时
  import { millisecondFormat } from '../utils'

  export default {
    props: {
      // 优惠券过期时间 单位s，从接口获取到的数据
      userCouponExpireTime: {
        type: [String, Number],
        default: '',
      },
    },
    components: {},
    data() {
      return {
        intervalId: null,
        currentTime: new Date().getTime(), // 当前时间
      }
    },
    computed: {
      time() {
        // 计算倒计时
        const userCouponExpireTime = this.userCouponExpireTime * 1000 || 0
        const { currentTime } = this
        // 倒计时 = 过期时间 - 当前时间
        const expireTime = userCouponExpireTime - currentTime // 过期时间：单位毫秒
        return millisecondFormat(expireTime) // 返回格式化后的HH:MM:SS
      },
    },
    mounted() {
      // 每秒执行一次
      this.intervalId = setInterval(() => {
        // 当倒计时为0时0分0秒时结束
        if (this.time === '00:00:00') {
          clearInterval(this.intervalId)
        }
        this.currentTime = new Date().getTime()
      }, 1000)
    },
    beforeDestroy() {
      clearInterval(this.intervalId)
    },
    methods: {},
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
